<template>
  <div class="context">
    <p class="title">利用手順</p>
    <div class="item">
      <ol>
        <li v-for="item in items" :key="item.number" v-html="item.html"></li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          number: 1,
          html: 
          `<b>事前の申請を実施ください。</b><br>
          <a href='https://forms.office.com/Pages/ResponsePage.aspx?id=RXGmqaZ1j0-txs0C0tgebxXwkMTTIu9AvZjp1VvRnrZUOE9QM0JEMUlWMVNHSjVFOEpCMDBNT0xGMS4u' target='_new'>
            こちらのフォーム
          </a>
          に従い、API利用申請を行ってください。<br>
          申請時には、以下の情報を入力ください。<br>
            <div style='padding-left: 4%;margin: 5px 10px;'>
              (1) お名前<br>
              (2) 所属組織（会社・大学・団体 等）<br>
              (3) ご連絡できる電話番号<br>
              (4) ご連絡できるメールアドレス<br>
              (5) 申請区分
                <ul style='padding-left: 4%; margin: 0 20px;font-size: 80%'>
                  <li>新規、変更、解約のいずれかを選択ください。</li>
                </ul>
              (6-1) 新規申請の場合<br>
                <ul style='padding-left: 4%; margin: 0 20px;font-size: 80%'>
                  <li>利用規約への同意</li>
                  <li>オープンデータ利用目的</li>
                </ul>
              (6-2) 変更・解約申請の場合<br>
                <ul style='padding-left: 4%; margin: 0 20px;font-size: 80%'>
                  <li>クライアントID</li>
                  <li>変更内容もしくは解約理由</li>
                </ul>
            </div>`,
        },
        { number: 2, html: "<b>アカウント登録作業（管理者側作業）</b>" },
        {
          number: 3,
          html: "<b>メールにてAPIアクセスに必要な情報が送付（管理者側作業）</b>",
        },
        { number: 4, html: "<b>利用開始</b>" },
      ],
    };
  },
};
</script>

<style scoped>
.context {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2vw;
  font-weight: 700;
  position: relative;
  margin-bottom: 4%;
}

.title::before {
  content: "";
  position: absolute;
  height: 70%;
  aspect-ratio: 2/10;
  background-color: #85bff2;
  left: -1.5vw;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.item {
  font-size: 1.4vw;
  line-height: 180%;
}

.item > ol {
  padding-left: 4%;
  display: flex;
  flex-direction: column;
  row-gap: 2vw;
}

.item > ol > li {
  padding-left: 2%;
}
</style>
